export const errMessage = (error, fallback) =>
  error?.response?.data?.error?.message || error?.message || fallback;

export const errCode = (error) => error?.response?.data?.error?.code || null;
